import React, { createContext, useState, useEffect, useContext } from 'react';
import { API_BASE_URL, AUTH_TOKEN_KEY } from '../utils/constants';

const UserContext = createContext();

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [selectedAppointmentDetails, setSelectedAppointmentDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getUserFromApi = async () => {
      try {
        // Skip API call for public routes
        const publicRoutes = ['/faq', '/privacy-policy', '/terms-and-conditions', '/contact-us', '/about-us'];
        const currentPath = window.location.pathname;
        if (publicRoutes.includes(currentPath)) {
          setLoading(false);
          return;
        }
        
        const token = localStorage.getItem(AUTH_TOKEN_KEY);
        if (token) {
          const response = await fetch(`${API_BASE_URL}api/doctor/profile`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });
          
          if (response.ok) {
            const data = await response.json();
            const formattedData = data.doctor;
            setUser({
              id: formattedData._id,
              name: formattedData.fullName,
              email: formattedData.email,
              mobile: formattedData.mobile,
              services: formattedData.services || [],
              speciality: formattedData.speciality || [],
              about: formattedData.about,
              education: formattedData.education || [],
              experience: formattedData.experience || [],
              profilePicture: formattedData.profilePicture || null,
              availableSlots: formattedData.availableSlots || [],
              location: formattedData.address || null,
            });
          } else {
            console.error("Failed to fetch user profile:", response.status);
          }
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      } finally {
        setLoading(false);
      }
    };

    getUserFromApi();
  }, []);

  const value = {
    user,
    setUser,
    selectedAppointmentDetails,
    setSelectedAppointmentDetails,
    loading
  };

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};